import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import BudgetCreate from '@app/views/ProjectBudget/Create';
import { memo } from 'react';

export default memo(
  withIfUser(BudgetCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
